import React, { Component } from 'react'
import { getRoundOff } from '../../SystemUtility/SystemUtility'

class UT_SystemUtility extends Component {
    componentDidMount() {
        this.test_getRoundOff()
    }
    test_getRoundOff = () => {
        alert('After press ok, you can check the result of the ')
        const testValues = [123.45, 1234.56, 12345, 123456.00]
        testValues.map((num) => {
            // console.log(num, getRoundOff(num))
        })
    }
    render() {
        return (
            <></>
        )
    }
}

export default UT_SystemUtility